import { useContext, useMemo } from 'react';
import { GameContext } from 'contexts/GameContext';
import Board from 'containers/Board';
import { Body, Row } from 'elements/Table';
import Cell from 'components/Cell';

const Answer = ({ index, across }) => {
  const { size, answers, clues, gridnums, isComplete } = useContext(GameContext);
  const clue = clues[across ? 'across' : 'down'][index];
  const answer = useMemo(() =>
    answers[across ? 'across' : 'down'][index].split(''),
    [answers, across, index]
  );
  const cells = useMemo(() => {
    const cells = [];
    const number = parseInt(clue.match(/\d+/)[0]);
    let position = gridnums.indexOf(number);
    while (cells.length < answer.length) {
      cells.push(position);
      position = across ? position + 1 : position + size.cols
    }
    return cells;
  }, [across, answer, clue, gridnums, size]);

  return (
    <Board
      m="0.5rem 0"
      width={`${100 / size.cols * answer.length}%`}
      isComplete={isComplete}
      noSelect
    >
      <Body>
        <Row>
          {cells.map((position, i) => (
            <Cell key={`letter-${position}`} position={position} across={across} />
          ))}
        </Row>
      </Body>
    </Board>
  )
}

export default Answer;
